import { Component, OnInit } from "@angular/core";
import { NgbModal, NgbModalRef, NgbModalOptions, ModalDismissReasons } from "@ng-bootstrap/ng-bootstrap";
import { NgxSpinnerService } from "ngx-spinner";
import { FormBuilder, FormGroup, Validators, FormControl } from "@angular/forms";
import Swal from "sweetalert2";
import { ActivatedRoute, Router } from '@angular/router';
import { ReportedAnswereService } from "../reported-answere.service";
@Component({
  selector: 'app-report-question',
  templateUrl: './report-question.component.html',
  styleUrls: ['./report-question.component.css']
})
export class ReportQuestionComponent implements OnInit {
  closeResult: string;
  userDetails: object;
  statusFormSubmitted: boolean = false;
  resetPasswordFormSubmitted: boolean = false;

  statusForm: FormGroup;
  formSubmitted: boolean = false;
  // reportQuestionList = [{ question: "Question 1", creationDate: 1570609584 }, { question: "Question 2", creationDate: 1570609584 }, { question: "Question 3", creationDate: 1570609582 }, { question: "Question 4", creationDate: 1570609523 }, { question: "Question 5", creationDate: 1570609524 }];
  NotificationForm: FormGroup;
  private modalRef: NgbModalRef;

  "questionList" = []
  modelOptions: NgbModalOptions = {
    backdrop: "static",
    keyboard: false
  };

  searchText: string = "";
  constructor(
    private modalService: NgbModal,
    private ReportedAnswereService: ReportedAnswereService,
    private formBuilder: FormBuilder,
    private spinner: NgxSpinnerService,
    private router: Router, private route: ActivatedRoute
  ) { }
  ngOnInit() {
    this.getreportList();
  }
  getreportList() {

    this.spinner.show();
    this.ReportedAnswereService.GetreportedQuestion().subscribe(res => {
      if (res["message"] = "Success") {
        this.questionList = res.data.reportedQuestionList;
        this.spinner.hide();
      } else {
        this.questionList = [];
        this.spinner.hide();
      }
    });
  }

  navigateReportDetail(row) {
    this.router.navigate(['main/report/report-detail-question/', row._id], { queryParams: { question: row.questionText }, preserveQueryParams: false });

  }
  reportAnswere(id, status) {

    let requestObj = {
      isReported: status,
      answerId: id
    }
    // this.spinner.show();


    this.ReportedAnswereService.reportedAnswere(requestObj).subscribe(data => {
      if (data["message"] == "Success") {

        Swal.fire("Success", "Answere Reported Successfully!", "success");
      } else {
        Swal.fire({
          type: "error",
          title: "Error",
          text: data.msg
        });
      }
    });
  }


  prepareUpdateStatusForm() {
    this.statusForm = this.formBuilder.group({
      newStatus: ["", [Validators.required]]
    });
  }
  updateUserStatusModal(row, content, btn) {
    btn && btn.parentElement && btn.parentElement.parentElement && btn.parentElement.parentElement.blur();
    this.userDetails = row;
    this.statusFormSubmitted = false;
    this.prepareUpdateStatusForm();
    this.modalRef = this.modalService.open(content, this.modelOptions);
    this.modalRef.result.then(
      result => {
        this.closeResult = `Closed with: ${result}`;
      },
      reason => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }
  reportedId:any;
  deleteStatusModal(row, content, btn) {
    btn && btn.parentElement && btn.parentElement.parentElement && btn.parentElement.parentElement.blur();
    this.reportedId = row;
    this.modalRef = this.modalService.open(content, this.modelOptions);
    this.modalRef.result.then(
      result => {
        this.closeResult = `Closed with: ${result}`;
      },
      reason => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }
  deleteRecord(record: any) {
    this.spinner.show();
    this.ReportedAnswereService.DeletereportedQuestion(this.reportedId).subscribe(res => {
      if ((res["message"] == "Success")) {
        this.getreportList();
        Swal.fire("Success", "Reported Question Deleted successfully!", "success");
        this.modalRef.close();
        this.spinner.hide();
      } else {
        Swal.fire({
          type: "error",
          title: "Error",
          text: res.msg
        });

      }
    });
    this.spinner.hide();

  }
  sendNotification(row, content, btn) {

    btn && btn.parentElement && btn.parentElement.parentElement && btn.parentElement.parentElement.blur();
    this.userDetails = row;
    this.formSubmitted = false;
    this.modalRef = this.modalService.open(content, this.modelOptions);
    this.modalRef.result.then(
      result => {
        this.closeResult = `Closed with: ${result}`;
      },
      reason => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }
  clearReport(data) {
    let request = {
      type:'question'
    }
    this.spinner.show();
    this.ReportedAnswereService.clearReport(request).subscribe(res => {
      if ((res["message"] == "Success")) {
        this.getreportList();
        this.modalRef.close();
        Swal.fire("Success", "Reported Question Clear successfully!", "success");
        this.spinner.hide();
      } else {
        Swal.fire({
          type: "error",
          title: "Error",
          text: res.msg
        });

      }
    });
  }
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }

}

